import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { ListResponse, UserRole } from "../../interfaces";
import { MemberAccess } from "@/interfaces/permission.interface";
import { UpdatePermissionDto } from "@/interfaces/dto/permission.dto";

export const accessApi = createApi({
  reducerPath: "accessApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/permission",
    credentials: "include",
  }),
  endpoints: (build) => ({
    getMemberAccess: build.query<ListResponse<MemberAccess>, { role?: UserRole }>({
      query: (params) => ({
        url: "/",
        method: "GET",
        params,
      }),
    }),
    updateMemberAccess: build.mutation<any, UpdatePermissionDto[]>({
      query: (body) => ({
        url: `/`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const { useGetMemberAccessQuery, useUpdateMemberAccessMutation } = accessApi;
